import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReusableModal from "../ExtraComponents/ReusableModal";
import { useDispatch } from "react-redux";
import { agentList , agentDetails , updateAuthAgent} from "../ReduxStore/Slice/Auth/AuthSlice";
import { get_Token } from "../Service/ThardPartyApi/ThardPartyAPI";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

const AdminHeader = () => {
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const agent_id = localStorage.getItem("agent_id");
  const [showplusModal, setPlusshowModal] = useState(false);
  const [showpencilModal, setPencilshowModal] = useState(false);
  const [agentListData, setAgentListData] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(agent_id);

  const handlePlusShowModal = () => setPlusshowModal(true);
  const handlePencilShowModal = () => setPencilshowModal(true);
  const handleCloseModal = () => {
    setPlusshowModal(false);
    setPencilshowModal(false);
  };

  const navigate = useNavigate();
  useEffect(() => {
    clearSession();
    getAgentList();
  }, []);



  const getAgentList = async () => {
    if (userDetails === null) return
    const req = { user_id: userDetails.id }
     await dispatch(agentList(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          const agent_payment_settings = JSON.parse(res.data[0].Agent.agent_payment_settings);
         // const agent_director_details = JSON.parse(res.data[0].Agent.agent_director_details);

          
          setAgentListData(res.data)
          if (localStorage.getItem("agent_id") === null || localStorage.getItem("agent_id") === undefined) {
            localStorage.setItem("agent_id", res.data[0].Agent.id)
            localStorage.setItem("agent_db", res.data[0].Agent.agent_db)
            localStorage.setItem("company_id", res.data[0].Agent.company_id)
            localStorage.setItem("agent_payment_settings", JSON.stringify(agent_payment_settings))
          //  localStorage.setItem("agent_director_details", JSON.stringify(agent_director_details))
            localStorage.setItem("agent_url", res.data[0].Agent.agent_url)

            await getTokens(res?.data[0]?.Agent?.agent_url , res?.data[0]?.Agent?.id)

            setSelectedAgent(res.data[0].Agent.id)
          }
        }
        else {
          setAgentListData([])
        }
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }


  const getTokens = async (url , agent_id) => {
    const req = { url: url }
    const response = await get_Token(req)
    if (response.IsSuccess) {
      localStorage.setItem('authClientToken', response.Result.AuthToken)
      await updateAgentAuthTokenFun(response.Result.AuthToken , agent_id)

    }
  }

 const updateAgentAuthTokenFun = async (crm_auth_token , agent_id) => {
  const req = { crm_auth_token: crm_auth_token , agent_id: agent_id }
  await dispatch(updateAuthAgent(req)).unwrap()
    .then(async (res) => {
      if (res.status) {
   
      }
      else {
        console.log("Token Not Updated")
      }
    })
    .catch((err) => {
      console.log("Error", err)
    })
}


  const clearSession = () => {
    if (token === null) return
    var decoded = jwtDecode(token);
    if (decoded.exp * 1000 < new Date().getTime()) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    }
  };

  const handleSelectAgent = (e) => {
    const agent_id = e.target.value;
    Swal.fire({
      title: "Are you sure?",
      text: "You want to change the agent?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async(result) => {
      if (result.isConfirmed) {
        localStorage.setItem("agent_id", agent_id);
        localStorage.setItem("company_id", agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.company_id)
        localStorage.setItem("agent_db", agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.agent_db)
        localStorage.setItem("agent_payment_settings", JSON.stringify(JSON.parse(agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.agent_payment_settings)))
       // localStorage.setItem("agent_director_details", JSON.stringify(JSON.parse(agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.agent_director_details)))
        localStorage.setItem("agent_url", agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.agent_url)
        setSelectedAgent(agent_id)

        let agent_url = agentListData.find(item => Number(item?.Agent?.id) === Number(agent_id))?.Agent?.agent_url;
       await getTokens(agent_url , agent_id)

        Swal.fire({
          title: "Success",
          text: "Agent Changed Successfully",
          icon: "success",
          timer: 1000,
        })
        .then(() => {
          window.location.reload();
        });
      }
    });
  }
  useEffect(() => {
    const toggleButton = document.querySelector('.toggle-header-btn');

    const toggleSidebar = () => {
      document.body.classList.toggle("toggle-sidebar");
    };

    if (toggleButton) {
      toggleButton.addEventListener("click", toggleSidebar);
    }

    return () => {
      if (toggleButton) {
        toggleButton.removeEventListener("click", toggleSidebar);
      }
    };
  }, []);
  

  return (
    <div>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      > 
      
        <div className="d-flex align-items-center justify-content-between">
          <a
            href="index.html"
            className="logo d-flex align-items-center justify-content-center"
          >
            <span className="logo-header">
              {" "}
              <img src="/assets/img/logo.png" alt="" />
            </span>
          </a>
           <div className="toggle-header-btn">
          <img src="/assets/img/toggle-img.png" alt="Toggle Sidebar" />
        </div>
        </div>
        <div className="header-select d-flex">
          <select
            className="form-select"
            id="floatingSelect"
            aria-label="Floating label select example"
            onChange={(e) => { handleSelectAgent(e) }}
            value={selectedAgent}
          >
            {agentListData.map((item, index) => {
              return <option key={index} value={item.Agent.id}>{item.Agent.agent_name}</option>
            }
            )}
          </select>

        </div>
        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item d-block d-lg-none">
              <a className="nav-link nav-icon search-bar-toggle " href="#">
                <i className="bi bi-search" />
              </a>
            </li>

            <>
            {/* <li className="nav-item dropdown me-2">
               
                  <img src="/assets/img/notification.png" alt="" />
               </li> */}
              {/* <li className="nav-item dropdown">
                <a
                  className="nav-link nav-icon"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <img src="/assets/img/notification.png" alt="" />
                </a>
                
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                  <li className="dropdown-header">
                    You have 4 new notifications
                    <a href="#">
                      <span className="badge rounded-pill bg-pink p-2 ms-2">
                        View all
                      </span>
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li className="notification-item">
                    <i className="bi bi-exclamation-circle text-warning" />
                    <div>
                      <h4>Lorem Ipsum</h4>
                      <p>Quae dolorem earum veritatis oditseno</p>
                      <p>30 min. ago</p>
                    </div>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li className="notification-item">
                    <i className="bi bi-x-circle text-danger" />
                    <div>
                      <h4>Atque rerum nesciunt</h4>
                      <p>Quae dolorem earum veritatis oditseno</p>
                      <p>1 hr. ago</p>
                    </div>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li className="notification-item">
                    <i className="bi bi-check-circle text-success" />
                    <div>
                      <h4>Sit rerum fuga</h4>
                      <p>Quae dolorem earum veritatis oditseno</p>
                      <p>2 hrs. ago</p>
                    </div>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li className="notification-item">
                    <i className="bi bi-info-circle text-primary" />
                    <div>
                      <h4>Dicta reprehenderit</h4>
                      <p>Quae dolorem earum veritatis oditseno</p>
                      <p>4 hrs. ago</p>
                    </div>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li className="dropdown-footer">
                    <a href="#">Show all notifications</a>
                  </li>
                </ul>
              
              </li> */}
              {/* End Notification Nav */}

              <li className="nav-item dropdown pe-3">
                <a
                  className="nav-link nav-profile d-flex align-items-center pe-0"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  <i className="bi bi-person"></i>
                </a>
                {/* End Profile Iamge Icon */}
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                  <li className="dropdown-header">
                    <h6>{userDetails?.user_name}</h6>
                    {/* <span>Web Designer</span> */}
                  </li>
                  {/* <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="users-profile.html"
                    >
                      <i className="bi bi-person" />
                      <span>My Profile</span>
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="users-profile.html"
                    >
                      <i className="bi bi-gear" />
                      <span>Account Settings</span>
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="pages-faq.html"
                    >
                      <i className="bi bi-question-circle" />
                      <span>Need Help?</span>
                    </a>
                  </li> */}
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center cursor-pointer"
                      onClick={() => {
                        //localStorage.removeItem("token");
                        //localStorage.removeItem("details");
                        localStorage.clear();
                        sessionStorage.clear();
                        navigate("/login");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-box-arrow-right" />
                      <span>Sign Out</span>
                    </a>
                  </li>
                </ul>
                {/* End Profile Dropdown Items */}
              </li>
              {/* End Profile Nav */}
            </>
          </ul>
        </nav>
      </header>
      <ReusableModal
        show={showplusModal}
        onClose={handleCloseModal}
        title={
          <>
            <i className="bi bi-filter" style={{ marginRight: "8px" }}></i>
            Filters
          </>
        }
        body={
          <div>
            <div className="row mb-4">
              <p className="text-semidark mb-1 font-14">Add Filters</p>
              <div className="col-sm-12">
                <input className="form-control " type="text" />
              </div>
            </div>
          </div>
        }
        footer={
          <>
            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="btn btn-pink"
              onClick={() => alert("Changes Saved!")}
            >
              Apply
            </button>
          </>
        }
      />
      <ReusableModal
        show={showpencilModal}
        onClose={handleCloseModal}
        title={
          <>
            <i className="bi bi-filter" style={{ marginRight: "8px" }}></i>
            Filters
          </>
        }
        body={
          <div>
            <div className="row mb-4">
              <p className="text-semidark mb-1 font-14">Status</p>
              <div className="col-sm-12 d-flex">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="gridCheck1"
                  />
                  <label className="form-check-label" htmlFor="gridCheck1">
                    Created
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="gridCheck2"
                    defaultChecked=""
                  />
                  <label className="form-check-label" htmlFor="gridCheck2">
                    Reviewed
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="gridCheck2"
                    defaultChecked=""
                  />
                  <label className="form-check-label" htmlFor="gridCheck2">
                    Accepted
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="gridCheck2"
                    defaultChecked=""
                  />
                  <label className="form-check-label" htmlFor="gridCheck2">
                    Rejected
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="gridCheck2"
                    defaultChecked=""
                  />
                  <label className="form-check-label" htmlFor="gridCheck2">
                    Sent
                  </label>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <p className="text-semidark mb-1 font-14">Date</p>
              <div className="col-sm-4">
                <input className="form-control date-feild" type="date" />
              </div>
            </div>
            <div className="row">
              <p className="text-semidark mb-1 font-14">Date Range</p>
              <div className="col-sm-4">
                <input className="form-control date-feild" type="date" />
              </div>
              <div className="col-sm-4">
                <input className="form-control date-feild" type="date" />
              </div>
            </div>
          </div>
        }
        footer={
          <>
            <button
              className="btn btn-outline-secondary"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="btn btn-pink"
              onClick={() => alert("Changes Saved!")}
            >
              Apply
            </button>
          </>
        }
      />
    </div>
  );
};

export default AdminHeader;
